import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrInstructionsText from 'client/components/SrInstructionsText/SrInstructionsText';

import './SrInstructionsTile.less';

const SrInstructionsTile = ({
  title,
  subtitle,
  color,
  iconUrl,
  iconDropShadowColor,
  iconSize,
  instructions,
  onClick,
  className,
  iconStyles,
}) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <SrBox
      styleName={classnames(className, 'SrInstructionsTile')}
      onClick={onClick}
      cursor={onClick ? 'pointer' : null}
    >
      <SrFlex align='center' justify='between'>
        <SrFlex align={subtitle ? null : 'center'}>
          <SrFlex
            backgroundColor={color}
            width='58px'
            height='65px'
            borderRadius='14px'
            align='center'
            justify='center'
            flexShrink='0'
          >
            <img
              alt='lock icon'
              src={iconUrl}
              width={iconSize}
              height='auto'
              style={{
                ...iconStyles,
                filter: iconDropShadowColor
                  ? `drop-shadow(3px 4px 11px ${iconDropShadowColor})`
                  : null,
              }}
            />
          </SrFlex>
          <SrBox marginLeft={isSmallScreen ? '12px' : '16px'}>
            <SrText
              font='greycliff'
              weight='800'
              size='18'
              color='blueGreycliff'
              lineHeight='22px'
            >
              {title}
            </SrText>
            {subtitle && (
              <SrBox marginTop='8px'>
                <SrBox
                  display='inlineBlock'
                  borderRadius='14px'
                  backgroundColor={color}
                  padding='7px 12px 9px'
                >
                  <SrText
                    font='greycliff'
                    weight='700'
                    size='16'
                    color='blueGreycliff'
                    lineHeight='21px'
                  >
                    {subtitle}
                  </SrText>
                </SrBox>
              </SrBox>
            )}
          </SrBox>
        </SrFlex>
        {onClick && (
          <SrBox marginLeft='20px'>
            <img alt='arrow' width='8px' src='/images/arrow-right-blue-rounded-medium.svg' />
          </SrBox>
        )}
      </SrFlex>
      {instructions && (
        <SrBox marginTop='16px'>
          <SrInstructionsText instructions={instructions} />
        </SrBox>
      )}
    </SrBox>
  );
};

SrInstructionsTile.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  color: PropTypes.string,
  iconUrl: PropTypes.string.isRequired,
  iconDropShadowColor: PropTypes.string,
  iconSize: PropTypes.string,
  iconStyles: PropTypes.object,
  onClick: PropTypes.func,
  instructions: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  className: PropTypes.string,
};

SrInstructionsTile.defaultProps = {
  color: '#F1F1F1',
  iconSize: '25px',
  iconStyles: {},
};

SrInstructionsTile.displayName = 'SrInstructionsTile';

export default SrInstructionsTile;
